export default "__VITE_ASSET__CIsEsWy2__"